import React from 'react'
import { useCompoundBody } from '@react-three/cannon'
import { MathUtils } from 'three';

export const OuterRing = ({ ...props }) => {
    const { position = [0, 1.6, 0], rotation = [0, .09, 0], radius = .85, segments = 32 } = props;
    const gapSizeInDeg = 17;
    const height = 0.07;
    const circleWithGap = 2 * Math.PI - MathUtils.degToRad(gapSizeInDeg);
    const boxLength = circleWithGap * radius / segments;
    let theta = MathUtils.degToRad(gapSizeInDeg) / 2;
    const thetaStep = circleWithGap / segments;


    const elements = [...Array(segments).keys()].map((el, idx) => {
        const px = radius * Math.sin(theta);
        const pz = radius * Math.cos(theta)
        theta += thetaStep
        return { type: 'Box', args: [boxLength, height, 0.02], position: [px, 0, pz], rotation: [0, theta - thetaStep, 0] }
    })

    const [ref] = useCompoundBody(() => ({
        mass: 0,
        position,
        rotation,
        shapes: elements
    }), null, [position, rotation, radius]);

    return (
        <group ref={ref} position={position} rotation={rotation}>
            {elements.map((el, idx) => (
                <mesh key={idx} position={el.position} rotation={el.rotation}>
                    <boxGeometry args={el.args} />
                    <meshPhongMaterial color={0xf0f0ff} />
                </mesh>
            ))}
        </group>
    )
}
export default OuterRing;